import React from "react";
import "./Banner.css";
import axios from "axios";
import Black_btn from "../../common-components/common-button/black-btn/Black_btn";

function Banner() {
  return (
    <section className="home-banner">
      <div className="container-fluid p-0">
        <div className="banner-div" >
          <img className="banner-img" src={process.env.PUBLIC_URL + '/assets/images/home/banner/home-banner2.png'} alt="home-banner" />
        </div>
        <div className="container">
          <Black_btn btn_name={'Contact Us'} btn_link={'/contact-us'} />
        </div>
      </div>
    </section>
  );
}

export default Banner;
